export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "A Little Bit About Me..",
  headline: "Pleasure to virtually meet you!",
  description:
    "My name is Mike Crifo, hailing out of Boston, Massachusetts, USA.  I am a newly trained " +
    "full stack developer, with emphasis on Javascript, HTML and CSS.  Prior to coding, I was associated " +
    "with the travel industry for over 19 years, in sales and management. \n\nFrom taking people around the globe " +
    "through airlines and cruise ships, to now taking them virtually through their iPhones and laptops from one " +
    "URL location to another, my goal is to create eye-catching and accessible user-friendly applications and websites " +
    "alike! I'm motivated to continue learning new skills and techniques for better application with the right company. " +
    "\n\n Please reach out to me using my contact me page (link on the button) or through any of my social media tabs listed on " +
    "my left side bar!",
  buttonLabel: "Back to Top!",
  imgStart: true,
  img: require("../../images/smallme.png"),
  alt: "Mike Crifo",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "resume",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "What Can I Do For You?",
  headline: "My Skills",
  description: "d",
  buttonLabel: "My Full Resume",
  imgStart: false,
  img: require("../../images/wollybeach.jpg"),
  alt: "Mike Crifo",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "projects",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "If You like what you See...",
  headline: "Please Reach Out to Connect!",
  description:
    "Whether you have any questions for me, or something that you " +
    "would like to create or improve, I'm ready to assist!\n\n Hit that 'Contact Me' " +
    "Button on the top right or add me on any of the social links below and I will circle back " +
     "as soon as I'm able!",
  buttonLabel: "Back to Top!",
  imgStart: true,
  img: require("../../images/DoctorComp.png"),
  alt: "Mike Crifo",
  dark: true,
  primary: true,
  darkText: false,
};
